export var paginationAction = ( val ) => {
    return {
        type: 'pagination',
        payload: val
    }
}
export var Storedirected = ( data ) => {
    return {
        type: 'storedirected',
        payload: data
    }
}
export var googlemapcenteraction = ( data ) => {
    return {
        type: 'mapcenter',
        payload: data
    }
}
export var locationsAction = ( data ) => {
    return {
        type: 'locations',
        payload: data
    }
}
export var categoryAction = ( data ) => {
    return {
        type: 'categorychoosed',
        payload: data
    }
}
export var mapAction = ( data ) => {
    return {
        type: 'mapdata',
        payload: data
    }
}
export var SiteDataAction = ( data ) => {
    return {
        type: 'sitedata',
        payload: data
    }
}
export var InfoBoxAction = ( data ) => {
    return {
        type: 'infobox',
        payload: data
    }
}
export var MapZoomAction = ( data ) => {
    return {
        type: 'mapzoom',
        payload: data
    }
}
export var InfoBoxCenterAction = ( data ) => {
    return {
        type: 'infoboxcenter',
        payload: data
    }
}
export var radiusAction = ( data ) => {
    return {
        type: 'mapradius',
        payload: data
    }
}